


// import React, { useRef, useState } from "react";
// import ReactPlayer from "react-player";
// import { Play, Pause, Volume2, VolumeX, Expand } from "lucide-react";
import { Bug } from "lucide-react"; // Add this at the top if not already

// const CustomVideoPlayer = ({ videoUrl, errorTimestamps }) => {
//   const playerRef = useRef(null);
//   const [playing, setPlaying] = useState(false);
//   const [muted, setMuted] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [duration, setDuration] = useState(0);

//   // Toggle play/pause
//   const togglePlay = () => setPlaying(!playing);
//   // Toggle mute
//   const toggleMute = () => setMuted(!muted);
//   // Seek to error timestamp
//   const seekTo = (timestamp) => {
//     if (playerRef.current) playerRef.current.seekTo(timestamp, "seconds");
//   };

//   // Format time in mm:ss format
//   const formatTime = (seconds) => {
//     if (isNaN(seconds)) return "00:00";
//     const minutes = Math.floor(seconds / 60);
//     const secs = Math.floor(seconds % 60);
//     return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
//   };

//   return (
//     <div className="relative w-full max-w-2xl mx-auto bg-black p-4 rounded-lg shadow-lg">
//       {/* Video Player */}
//       <ReactPlayer
//         ref={playerRef}
//         url={videoUrl}
//         playing={playing}
//         muted={muted}
//         controls={false} // Custom Controls
//         width="100%"
//         height="auto"
//         onProgress={({ playedSeconds }) => setProgress(playedSeconds)}
//         onDuration={(dur) => setDuration(dur)}
//       />

//       {/* Controls */}
//       <div className="flex items-center justify-between p-2 text-white bg-black/80 rounded-b-lg">
//         {/* Play/Pause */}
//         <button onClick={togglePlay}>{playing ? <Pause /> : <Play />}</button>

//         {/* Progress Bar with Current Time & Duration */}
//         <div className="relative w-full mx-4 flex items-center gap-2">
//           {/* Current Time */}
//           <span className="text-xs text-white">{formatTime(progress)}</span>

//           <div className="relative flex-1 h-2 bg-gray-600 rounded-lg overflow-hidden">
//             {/* Progress Bar */}
//             <div
//               className="h-2 bg-blue-500 rounded-lg transition-all duration-200"
//               style={{ width: `${(progress / duration) * 100}%` }}
//             ></div>

//             {/* Error Indicators on Timeline */}
//             {errorTimestamps.map((timestamp, index) => (
//               <div
//                 key={index}
//                 className="absolute top-1/2 -translate-y-1/2 h-2 w-2 bg-red-500 rounded-full cursor-pointer border-2 border-white shadow-md"
//                 style={{ left: `${(timestamp / duration) * 100}%` }}
//                 onClick={() => seekTo(timestamp)}
//               ></div>
//             ))}
//           </div>

//           {/* Total Duration */}
//           <span className="text-xs text-white">{formatTime(duration)}</span>
//         </div>

//         {/* Volume Control */}
//         <button onClick={toggleMute}>{muted ? <VolumeX /> : <Volume2 />}</button>

//         {/* Fullscreen Button */}
//         <button onClick={() => document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen()}>
//           <Expand />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CustomVideoPlayer;


// import React, { useRef, useState, useMemo } from "react";
// import ReactPlayer from "react-player";
// import { Play, Pause, Volume2, VolumeX, Expand } from "lucide-react";

// const CustomVideoPlayer = ({ videoUrl, errorTimestamps }) => {
//   const playerRef = useRef(null);
//   const [playing, setPlaying] = useState(false);
//   const [muted, setMuted] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [duration, setDuration] = useState(1); // Avoid division by zero

//   // Toggle play/pause
//   const togglePlay = () => setPlaying(!playing);
//   // Toggle mute
//   const toggleMute = () => setMuted(!muted);
//   // Seek to error timestamp
//   const seekTo = (timestamp) => {
//     if (playerRef.current) playerRef.current.seekTo(timestamp, "seconds");
//   };

//   // Format time in mm:ss format
//   const formatTime = (seconds) => {
//     if (isNaN(seconds)) return "00:00";
//     const minutes = Math.floor(seconds / 60);
//     const secs = Math.floor(seconds % 60);
//     return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
//   };

//   // Memoize error markers to prevent unnecessary re-renders
//   const errorMarkers = useMemo(
//     () =>
//       errorTimestamps.map((timestamp, index) => {
//         const position = Math.round((timestamp / duration) * 100);
//         return (
//           <div
//             key={index}
//             className="absolute top-1/2 -translate-y-1/2 h-2 w-2 bg-red-500 rounded-full cursor-pointer border-2 border-white shadow-md"
//             style={{ left: `${position}%` }}
//             onClick={() => seekTo(timestamp)}
//           ></div>
//         );
//       }),
//     [errorTimestamps, duration]
//   );

//   return (
//     <div className="relative w-full max-w-2xl mx-auto bg-black p-4 rounded-lg shadow-lg">
//       {/* Video Player */}
//       <ReactPlayer
//         ref={playerRef}
//         url={videoUrl}
//         playing={playing}
//         muted={muted}
//         controls={false} // Custom Controls
//         width="100%"
//         height="auto"
//         onProgress={({ playedSeconds }) => setProgress(playedSeconds)}
//         onDuration={(dur) => setDuration(dur || 1)} // Prevent division by zero
//       />

//       {/* Controls */}
//       <div className="flex items-center justify-between p-2 text-white bg-black/80 rounded-b-lg">
//         {/* Play/Pause */}
//         <button onClick={togglePlay}>{playing ? <Pause /> : <Play />}</button>

//         {/* Progress Bar with Current Time & Duration */}
//         <div className="relative flex-1 mx-4 flex items-center gap-2">
//           {/* Current Time */}
//           <span className="text-xs text-white min-w-[40px]">{formatTime(progress)}</span>

//           {/* Progress Bar Container */}
//           <div className="relative flex-1 h-2 bg-gray-600 rounded-lg overflow-hidden">
//             {/* Progress Bar */}
//             <div
//               className="h-2 bg-blue-500 rounded-lg transition-transform duration-100 ease-linear will-change-transform"
//               style={{ transform: `translateX(${(progress / duration) * 100}%)` }}
//             ></div>

//             {/* Error Indicators on Timeline */}
//             {errorMarkers}
//           </div>

//           {/* Total Duration */}
//           <span className="text-xs text-white min-w-[40px]">{formatTime(duration)}</span>
//         </div>

//         {/* Volume Control */}
//         <button onClick={toggleMute}>{muted ? <VolumeX /> : <Volume2 />}</button>

//         {/* Fullscreen Button */}
//         <button onClick={() => document.fullscreenElement ? document.exitFullscreen() : document.documentElement.requestFullscreen()}>
//           <Expand />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CustomVideoPlayer;


//attempt -1

// import React, { useRef, useState, useMemo } from "react";
// import ReactPlayer from "react-player";
// import { Play, Pause, Volume2, VolumeX, Expand } from "lucide-react";

// const CustomVideoPlayer = ({ videoUrl, errorTimestamps }) => {
//   const playerRef = useRef(null);
//   const containerRef = useRef(null);

//   const [playing, setPlaying] = useState(false);
//   const [muted, setMuted] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [duration, setDuration] = useState(1); // Avoid division by zero

//   // Toggle play/pause
//   const togglePlay = () => setPlaying(!playing);
//   // Toggle mute
//   const toggleMute = () => setMuted(!muted);
//   // Seek to error timestamp
//   const seekTo = (timestamp) => {
//     if (playerRef.current) playerRef.current.seekTo(timestamp, "seconds");
//   };

//   // Handle fullscreen toggle
//   const toggleFullscreen = () => {
//     if (document.fullscreenElement) {
//       document.exitFullscreen();
//     } else if (containerRef.current) {
//       containerRef.current.requestFullscreen();
//     }
//   };

//   // Format time in mm:ss
//   const formatTime = (seconds) => {
//     if (isNaN(seconds)) return "00:00";
//     const minutes = Math.floor(seconds / 60);
//     const secs = Math.floor(seconds % 60);
//     return `${String(minutes).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
//   };

//   // Error markers (dots on progress bar)
//   const errorMarkers = useMemo(() => {
//     return errorTimestamps.map((timestamp, index) => {
//       const position = Math.round((timestamp / duration) * 100);
//       return (
//         <div
//           key={index}
//           className="absolute top-1/2 -translate-y-1/2 h-2 w-2 bg-red-500 rounded-full cursor-pointer border-2 border-white shadow-md"
//           style={{ left: `${position}%` }}
//           onClick={() => seekTo(timestamp)}
//         ></div>
//       );
//     });
//   }, [errorTimestamps, duration]);

//   return (
//     <div
//       ref={containerRef}
//       className="relative w-full max-w-2xl mx-auto bg-gray-900 rounded-lg shadow-xl overflow-hidden"
//     >
//       {/* Video Player */}
//       <ReactPlayer
//         ref={playerRef}
//         url={videoUrl}
//         playing={playing}
//         muted={muted}
//         controls={false}
//         width="100%"
//         height="auto"
//         onProgress={({ playedSeconds }) => setProgress(playedSeconds)}
//         onDuration={(dur) => setDuration(dur || 1)}
//         onEnded={() => setPlaying(false)}
//       />

//       {/* Controls */}
//       <div className="flex items-center justify-between px-3 py-2 text-white bg-black/70">
//         {/* Play/Pause */}
//         <button onClick={togglePlay}>{playing ? <Pause /> : <Play />}</button>

//         {/* Progress */}
//         <div className="relative flex-1 mx-4 flex items-center gap-2">
//           <span className="text-xs min-w-[40px]">{formatTime(progress)}</span>
//           <div className="relative flex-1 h-2 bg-gray-700 rounded-full overflow-hidden">
//             {/* Fill */}
//             <div
//               className="absolute left-0 top-0 h-full bg-blue-500 rounded-full"
//               style={{ width: `${(progress / duration) * 100}%` }}
//             ></div>
//             {/* Error markers */}
//             {errorMarkers}
//           </div>
//           <span className="text-xs min-w-[40px]">{formatTime(duration)}</span>
//         </div>

//         {/* Mute/Unmute */}
//         <button onClick={toggleMute}>{muted ? <VolumeX /> : <Volume2 />}</button>

//         {/* Fullscreen */}
//         <button onClick={toggleFullscreen}>
//           <Expand />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CustomVideoPlayer;




//attemp -2
// import React, { useRef, useState, useMemo, useCallback } from "react";
// import ReactPlayer from "react-player";
// import { Play, Pause, Volume2, VolumeX, Expand } from "lucide-react";

// const CustomVideoPlayer = ({ videoUrl, errorTimestamps }) => {
//   const playerRef = useRef(null);
//   const containerRef = useRef(null);
//   const progressBarRef = useRef(null);

//   const [playing, setPlaying] = useState(false);
//   const [muted, setMuted] = useState(false);
//   const [progress, setProgress] = useState(0);
//   const [duration, setDuration] = useState(1);

//   // Toggle play/pause
//   const togglePlay = () => setPlaying((prev) => !prev);
//   const toggleMute = () => setMuted((prev) => !prev);
//   const toggleFullscreen = () => {
//     if (document.fullscreenElement) {
//       document.exitFullscreen();
//     } else if (containerRef.current) {
//       containerRef.current.requestFullscreen();
//     }
//   };

//   const seekTo = (seconds) => {
//     if (playerRef.current) {
//       playerRef.current.seekTo(seconds, "seconds");
//       setProgress(seconds); // Immediately reflect UI
//     }
//   };

//   const formatTime = (seconds) => {
//     if (isNaN(seconds)) return "00:00";
//     const mins = Math.floor(seconds / 60);
//     const secs = Math.floor(seconds % 60);
//     return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
//   };

//   const handleBarClick = useCallback(
//     (e) => {
//       const bar = progressBarRef.current;
//       if (!bar) return;

//       const rect = bar.getBoundingClientRect();
//       const clickX = e.clientX - rect.left;
//       const percentage = clickX / rect.width;
//       const newTime = duration * percentage;
//       seekTo(newTime);
//     },
//     [duration]
//   );

//   const errorMarkers = useMemo(() => {
//     return errorTimestamps.map((timestamp, index) => {
//       const left = `${(timestamp / duration) * 100}%`;
//       return (
//         <div
//           key={index}
//           className="absolute top-1/2 -translate-y-1/2 h-2 w-2 bg-red-500 rounded-full cursor-pointer border-2 border-white shadow"
//           style={{ left }}
//           onClick={(e) => {
//             e.stopPropagation();
//             seekTo(timestamp);
//           }}
//         />
//       );
//     });
//   }, [errorTimestamps, duration]);

//   return (
//     <div
//       ref={containerRef}
//       className="relative w-full max-w-2xl mx-auto bg-gray-900 rounded-lg shadow-xl overflow-hidden"
//     >
//       {/* Player */}
//       <ReactPlayer
//         ref={playerRef}
//         url={videoUrl}
//         playing={playing}
//         muted={muted}
//         controls={false}
//         width="100%"
//         height="auto"
//         onProgress={({ playedSeconds }) => setProgress(playedSeconds)}
//         onDuration={(dur) => setDuration(dur || 1)}
//         onEnded={() => setPlaying(false)}
//       />

//       {/* Controls */}
//       <div className="flex items-center justify-between px-3 py-2 text-white bg-black/70">
//         {/* Play/Pause */}
//         <button onClick={togglePlay}>{playing ? <Pause /> : <Play />}</button>

//         {/* Progress Section */}
//         <div className="relative flex-1 mx-4 flex items-center gap-2">
//           <span className="text-xs min-w-[40px]">{formatTime(progress)}</span>

//           {/* Clickable Progress Bar */}
//           <div
//             ref={progressBarRef}
//             onClick={handleBarClick}
//             className="relative flex-1 h-2 bg-gray-700 rounded-full cursor-pointer"
//           >
//             {/* Filled Progress */}
//             <div
//               className="absolute top-0 left-0 h-full bg-blue-500 rounded-full transition-all duration-150"
//               style={{ width: `${(progress / duration) * 100}%` }}
//             />
//             {/* Error markers */}
//             {errorMarkers}
//           </div>

//           <span className="text-xs min-w-[40px]">{formatTime(duration)}</span>
//         </div>

//         {/* Mute/Unmute */}
//         <button onClick={toggleMute}>{muted ? <VolumeX /> : <Volume2 />}</button>

//         {/* Fullscreen */}
//         <button onClick={toggleFullscreen}>
//           <Expand />
//         </button>
//       </div>
//     </div>
//   );
// };

// export default CustomVideoPlayer;


//attemp-3
import React, { useRef, useState, useMemo, useCallback, useEffect } from "react";
import ReactPlayer from "react-player";
import { Play, Pause, Volume2, VolumeX, Expand } from "lucide-react";

const CustomVideoPlayer = ({ videoUrl, errorTimestamps }) => {
  const playerRef = useRef(null);
  const containerRef = useRef(null);
  const progressBarRef = useRef(null);

  const [playing, setPlaying] = useState(false);
  const [muted, setMuted] = useState(false);
  const [progress, setProgress] = useState(0);
  const [duration, setDuration] = useState(1);

  const togglePlay = () => setPlaying((prev) => !prev);
  const toggleMute = () => setMuted((prev) => !prev);
  const toggleFullscreen = () => {
    if (document.fullscreenElement) {
      document.exitFullscreen();
    } else if (containerRef.current) {
      containerRef.current.requestFullscreen();
    }
  };

  const seekTo = (seconds) => {
    if (playerRef.current) {
      playerRef.current.seekTo(seconds, "seconds");
      setProgress(seconds);
    }
  };

  const formatTime = (seconds) => {
    if (isNaN(seconds)) return "00:00";
    const mins = Math.floor(seconds / 60);
    const secs = Math.floor(seconds % 60);
    return `${String(mins).padStart(2, "0")}:${String(secs).padStart(2, "0")}`;
  };

  const handleBarClick = useCallback(
    (e) => {
      const bar = progressBarRef.current;
      if (!bar) return;

      const rect = bar.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const percentage = clickX / rect.width;
      const newTime = duration * percentage;
      seekTo(newTime);
    },
    [duration]
  );

  // const errorMarkers = useMemo(() => {
  //   return errorTimestamps.map((timestamp, index) => {
  //     const left = `${(timestamp / duration) * 100}%`;
  //     return (
  //       <div
  //         key={index}
  //         className="absolute top-1/2 -translate-y-1/2 h-2 w-2 bg-red-500 rounded-full cursor-pointer border-2 border-white shadow"
  //         style={{ left }}
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           seekTo(timestamp);
  //         }}
  //       />
  //     );
  //   });
  // }, [errorTimestamps, duration]);


  const errorMarkers = useMemo(() => {
    return errorTimestamps.map((timestamp, index) => {
      const left = `${(timestamp / duration) * 100}%`;
      return (
        <div
          key={index}
          title={`Error at ${formatTime(timestamp)}`}
          className="absolute top-1/2 -translate-y-1/2 h-2 w-2 bg-red-500 rounded-full cursor-pointer border-2 border-white shadow transition-all duration-200 transform hover:scale-150"
          style={{ left }}
          onClick={(e) => {
            e.stopPropagation();
            seekTo(timestamp);
          }}
        />
      );
    });
  }, [errorTimestamps, duration]);
  

  useEffect(() => {
    let animationFrameId;
  
    const updateProgress = () => {
      if (playerRef.current && playing) {
        const currentTime = playerRef.current.getCurrentTime?.();
        if (!isNaN(currentTime)) {
          setProgress(currentTime);
        }
        animationFrameId = requestAnimationFrame(updateProgress);
      }
    };
  
    if (playing) {
      animationFrameId = requestAnimationFrame(updateProgress);
    }
  
    return () => cancelAnimationFrame(animationFrameId);
  }, [playing]);


  // const errorMarkers = useMemo(() => {
  //   return errorTimestamps.map((timestamp, index) => {
  //     const left = `${(timestamp / duration) * 100}%`;
  //     return (
  //       <div
  //         key={index}
  //         title={`Error at ${formatTime(timestamp)}`}
  //         className="absolute top-1/2 -translate-y-1/2 -translate-x-1/2 cursor-pointer"
  //         style={{ left }}
  //         onClick={(e) => {
  //           e.stopPropagation();
  //           seekTo(timestamp);
  //         }}
  //       >
  //         <Bug
  //           size={16}
  //           className="text-red-500 drop-shadow transition-transform duration-200 hover:scale-150"
  //         />
  //       </div>
  //     );
  //   });
  // }, [errorTimestamps, duration]);
  return (
    <div
      ref={containerRef}
      className="relative w-full max-w-2xl mx-auto bg-gray-900 rounded-lg shadow-xl overflow-hidden"
    >
      {/* Player */}
      <ReactPlayer
        ref={playerRef}
        url={videoUrl}
        playing={playing}
        muted={muted}
        controls={false}
        width="100%"
        height="auto"
        onProgress={({ playedSeconds }) => setProgress(playedSeconds)}
        onDuration={(dur) => setDuration(dur || 1)}
        onEnded={() => setPlaying(false)}
      />

      {/* Controls */}
      <div className="flex items-center justify-between px-3 py-2 text-white bg-black/70">
        {/* Play/Pause */}
        <button onClick={togglePlay}>{playing ? <Pause /> : <Play />}</button>

        {/* Progress Section */}
        <div className="relative flex-1 mx-4 flex items-center gap-2">
          <span className="text-xs min-w-[40px]">{formatTime(progress)}</span>

          {/* Clickable Progress Bar */}
          <div
            ref={progressBarRef}
            onClick={handleBarClick}
            className="relative flex-1 h-2 bg-gray-700 rounded-full cursor-pointer"
          >
            {/* Filled Progress - White Color */}
            <div
              className="absolute top-0 left-0 h-full bg-white rounded-full transition-all duration-150"
              style={{ width: `${(progress / duration) * 100}%` }}
            />
            {/* Error markers */}
            {errorMarkers}
          </div>

          <span className="text-xs min-w-[40px]">{formatTime(duration)}</span>
        </div>

        {/* Mute/Unmute */}
        <button onClick={toggleMute}>
          {muted ? <VolumeX /> : <Volume2 />}
        </button>

        {/* Fullscreen */}
        <button onClick={toggleFullscreen}>
          <Expand />
        </button>
      </div>
    </div>
  );
};

export default CustomVideoPlayer;
